import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateReviewComponent } from './create-review.component';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { AuthGuardService } from 'src/app/guards/auth-guard.service';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.createReview.pageInRouting,
    data: { data: PAGES_AND_PATHS.createReview },
    component: CreateReviewComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./create-review.module').then(m => m.CreateReviewModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateReviewRoutingModule { }
